import { withStyles } from '@material-ui/core';
import Action from '../../common/components/CardAction';
import styles from './styles';
import { getLocationCardDetails } from '../../utils';

const LocationDisplay = ({
  location,
  openForm,
  selectPolygonOnMap,
  onDelete,
  classes,
  isSelectedOnMap
}) => {
  const labelsList = getLocationCardDetails(location);
  return (
    <div
      className={`${classes.container} ${isSelectedOnMap ? classes.highlightedCard : ''}`}
      onClick={() => selectPolygonOnMap([location.locationMappingId])}>
      <div className={classes.cardContainer}>
        <span className={classes.locationName}>{location.locationName}</span>
        <div className={classes.equipContainer}>
          {labelsList.map((labelItem, index) => (
            <>
              <span className={`${classes.equipmentLabel} ${index ? classes.divider : ''}`}>
                {labelItem.label}:
              </span>
              <span className={classes.equipmentValue}>{labelItem.size}</span>
            </>
          ))}
          {location?.isLiftGateRequired && (
            <span
              className={`${classes.liftGateLabel} ${
                labelsList.length == 1 ? classes.divider : ''
              }`}>
              <span className={classes.equipmentLabel}>Requires LG</span>
            </span>
          )}
        </div>
      </div>
      <Action
        onEdit={() => openForm(location.locationMappingId)}
        onDelete={() => onDelete(location)}
      />
    </div>
  );
};

export default withStyles(styles)(LocationDisplay);
